"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AgendaProIsotypeRebranding = function AgendaProIsotypeRebranding(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: 25 / 24 * size,
    height: size,
    fill: "none",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5262 21.2986H2.51234C1.65768 21.2986 0.964844 21.9914 0.964844 22.8461V32.86C0.964844 33.7146 1.65768 34.4075 2.51234 34.4075H12.5262C13.3809 34.4075 14.0737 33.7146 14.0737 32.86V22.8461C14.0737 21.9914 13.3809 21.2986 12.5262 21.2986Z",
    fill: "url(#paint0_linear_2757_2988)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98438 2.6725V12.6864C5.98438 13.5411 6.6772 14.2339 7.53188 14.2339H19.5915C20.4461 14.2339 21.139 14.9268 21.139 15.7814V27.5825C21.139 28.4372 21.8318 29.13 22.6865 29.13H32.7004C33.555 29.13 34.2479 28.4372 34.2479 27.5825V2.6725C34.2479 1.81783 33.555 1.125 32.7004 1.125H7.53188C6.6772 1.125 5.98438 1.81783 5.98438 2.6725Z",
    fill: "url(#paint1_linear_2757_2988)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_2988",
    x1: "2.09566",
    y1: "33.2767",
    x2: "12.8734",
    y2: "22.499",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": "#FA23C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.58",
    "stop-color": "#FD5782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    "stop-color": "#FF7A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2757_2988",
    x1: "13.1077",
    y1: "22.1361",
    x2: "33.5626",
    y2: "1.68133",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.09",
    "stop-color": "#812DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.21",
    "stop-color": "#6E3AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.72",
    "stop-color": "#2572EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.95",
    "stop-color": "#0989E9"
  }))));
};
var _default = exports["default"] = AgendaProIsotypeRebranding;